// Puente con la extensión de Chrome "TikControl Tracking" (backoffice/extension).
// El backoffice le pide la sesión de TikTok abierta en el navegador y la manda al
// Worker con la sesión de administrador; la extensión no guarda nada.

// Fijado por la clave del manifest.json: igual en todas las instalaciones.
export const TRACKING_EXTENSION_ID = 'bglmndahhemlbjafikddfaffenhoekgh';
const TIMEOUT_MS = 5000;

function sendToExtension(message) {
  return new Promise((resolve) => {
    const rt = typeof chrome !== 'undefined' && chrome ? chrome.runtime : null;
    if (!rt || typeof rt.sendMessage !== 'function') {
      resolve({ ok: false, error: 'no_chrome' });
      return;
    }
    let done = false;
    const finish = (value) => {
      if (done) return;
      done = true;
      resolve(value);
    };
    const timer = setTimeout(() => finish({ ok: false, error: 'timeout' }), TIMEOUT_MS);
    try {
      rt.sendMessage(TRACKING_EXTENSION_ID, message, (response) => {
        clearTimeout(timer);
        if (rt.lastError) {
          finish({ ok: false, error: 'not_installed', detail: rt.lastError.message });
          return;
        }
        finish(response || { ok: false, error: 'empty' });
      });
    } catch (e) {
      clearTimeout(timer);
      finish({ ok: false, error: 'not_installed', detail: e && e.message });
    }
  });
}

/** ¿Está instalada la extensión en este navegador? */
export async function detectExtension() {
  const r = await sendToExtension({ type: 'tc:ping' });
  return { installed: !!r.ok, version: r.version || '', error: r.ok ? '' : r.error };
}

/**
 * Sesión de TikTok abierta en el navegador:
 *   { ok: true, session: { sessionId, ttTargetIdc, expiresAt }, account: { username, userId, displayName } | null }
 *   { ok: false, error: 'no_session' | 'not_installed' | 'no_chrome' | 'timeout' | ... }
 */
export async function readTikTokSession() {
  return sendToExtension({ type: 'tc:getTikTokSession' });
}
